import styled from 'styled-components';
import Image from 'next/image';
import { optimizeVideoUrl } from '../utils/videoLinkOptimize';
import { RefObject, useEffect, useState } from 'react';

interface IProps {
  title: string;
  snippet: string;
  media: string;
  altImage?: string;
  video: boolean;
  landing?: boolean;
  totalReviews?: Record<string, any>;
  rating?: number;
  trustworthy?: boolean;
  partner?: boolean;
  partnerApplyRef?: RefObject<HTMLButtonElement>;
  subheader?: string;
}
interface StyleProps {
  isVideo: boolean;
}
const PageHeroStyle = styled.div`
  height: 55vh;
  position: relative;
  overflow: hidden !important;

  display: flex;
  @media (max-width: 540px) {
    height: 50vh;
  }
  .PageHero_container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    z-index: 30;
    @media (max-width: 540px) {
      gap: 1rem;
    }
  }
`;
const StyledImage = styled(Image)`
  z-index: 0;
  object-fit: cover;
`;
const StyledVideo = styled.video`
  height: 60vh;
  max-height: 69vh;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  top: 0;
  @media (max-width: 2200px) {
    height: 69vh;
    max-height: 69vh;
  }
  @media (max-width: 540px) {
    height: 50vh;
  }
  width: 100vw !important;
  z-index: 1;
`;
const PageHero = ({
  title,
  snippet,
  media,
  altImage,
  video,
  landing,
  partner,
  partnerApplyRef,
  trustworthy,
  subheader
}: IProps): JSX.Element => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setIsDesktop(true);
    }
  }, []);

  return (
    <section className="Hero_Section  overflow-hidden">
      <PageHeroStyle
        id="PageHero"
        className="relative bg-no-repeat bg-cover bg-center flex justify-start items-center "
      >
        <div className="absolute w-full h-full z-30 bg-opacity-40 bg-black " />

        <div
          className={`${
            !video && 'absolute top-0 left-0 w-[100%] h-[inherit]  z-20'
          }`}
        ></div>
        {!video && (
          <StyledImage
            src={media}
            alt={altImage ? altImage : title}
            fill
            quality={80}
            priority={isDesktop}
            // sizes="(max-width: 768px) 50vw"
          />
        )}
        {video && (
          <>
            <div className="hidden xl:flex ">
              <StyledVideo
                src={optimizeVideoUrl(media)}
                autoPlay
                muted
                loop
                playsInline
                preload="none"
                poster="/placeholder.webp"
              >
                Your browser does not support the video tag.
              </StyledVideo>
            </div>

            <StyledImage
              alt="guidesImage"
              src="https://res.cloudinary.com/see-sight-tours/image/upload/w_350,q_300/v1682684366/strapi/image1_f0cf2fc9c5.webp"
              layout="fill"
              className="flex xl:hidden"
              priority={true}
              quality={60}
            />
          </>
        )}
        <div className="PageHero_container flex flex-col ">
          <div className="flex-col  text-white text-center w-full ">
            <h1 className="text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-white  ">
              {' '}
              {landing && (
                <span className="text-[#F15C5A] opacity-80 ">ULTRA</span>
              )}{' '}
              {title.indexOf('ULTRA') !== -1 ? title.split('ULTRA')[1] : title}
            </h1>
            {!landing && subheader && (
              <div className="md:flex md:justify-center md:mt-4 lg:mt-6 mb-4">
                <p className="text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl font-medium text-white md:text-center md:max-w-4xl md:px-4 md:leading-relaxed">
                  {subheader}
                </p>
              </div>
            )}

            {trustworthy && (
              <div className="text-white text-center mt-6">
                <h3 className="text-sm sm:text-[22px] lg:text-[28px] font-[600]">
                  Personal | Authentic | Local
                </h3>
              </div>
            )}
            {snippet !== 'Size Matters' && (
              <p className="w-full text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-normal text-center text-white mt-2 md:mt-6 ">
                {snippet}
              </p>
            )}
            {partner && (
              <div className="flex justify-center mt-5">
                <button
                  onClick={() => {
                    partnerApplyRef?.current?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center'
                    });
                  }}
                  className="p-3 bg-[#F15C5A] text-white rounded-xl"
                >
                  Let&apos;s Partner Up
                </button>
              </div>
            )}
          </div>
        </div>
      </PageHeroStyle>
    </section>
  );
};
export default PageHero;
